import {useState} from "react";
import {Checkbox} from "antd";

import {DashboardIncidentPopupDataType} from "~/data/dashboard/incident/use-dashboard-incident-popup.interface";

const IncidentPopup = ({
    boardId,
    data,
    close,
}: {
    boardId: number;
    data: DashboardIncidentPopupDataType[];
    close: () => void;
}) => {
    const [notToday, setNotToday] = useState<boolean>(false);

    return (
        <div style={{width: "100%", height: "100%"}}>
            {data.map((item, idx) => (
                <img alt={"image"} src={"data:image/png;base64," + item.base64} key={idx} style={{width: "100%"}} />
            ))}

            <div
                style={{
                    width: "100%",
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    boxSizing: "border-box",
                }}
            >
                <Checkbox checked={notToday} onChange={(e) => setNotToday(e.target.checked)} />
                <span style={{fontSize: 14, marginRight: 12}}>오늘 그만 보기</span>
                <button
                    onClick={() => {
                        if (notToday) {
                            const now = new Date();
                            now.setHours(23, 59, 59, 999);
                            document.cookie = `incidentPopup_${boardId}=1; expires=${now.toUTCString()}; path=/`;
                        }
                        close();
                    }}
                    style={{
                        width: 50,
                        height: 25,
                        backgroundColor: "white",
                        border: "1px solid gray",
                        borderRadius: 5,
                        cursor: "pointer",
                    }}
                >
                    닫기
                </button>
            </div>
        </div>
    );
};

export {IncidentPopup};
